module.exports = __webpack_public_path__ + "static/media/carrito.4ed6e33e.png";